import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import { Link, useParams } from 'react-router-dom';


const ViewPostScheduleDet = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const PostId = useParams("PostId")
    const UserID = localStorage.getItem("UserID")
    const AccountType = localStorage.getItem("AccountType")

    const handleTime = (scheduledTimeAsPerZone) => {
        if (!scheduledTimeAsPerZone) {
          return { time: 'No time available' }; // Handle empty or undefined input
        }
    
        // Split the string by 'T' and take the second part (time)
        const timeString = scheduledTimeAsPerZone?.split('T')[1];
    
        // If there's a time part, format it; otherwise, return an error message
        if (timeString) {
          const timeParts = timeString.split(':');
          const formattedTime = `${timeParts[0]}:${timeParts[1]}`; // Get hours and minutes
          return { time: formattedTime };
        } else {
          return { time: 'Invalid time' };
        }
      };
    useEffect(() => {
        const fetchPosts = async () => {
            try {
                console.log(PostId)
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getscheduledpostsbyPostId/${PostId.PostId}`);
                setPosts(response.data);
                 
                 setLoading(false);
            } catch (err) {
                console.error('Failed to fetch posts:', err.message);
                setError('Failed to fetch posts');
                setLoading(false);
            }
        };
fetchPosts();
    }, []);
   
    


    const {  time } = handleTime(posts[0]?.ScheduledTimeAsPerZone);

    return (
        <SideNavbar>
            <div className='container'>
            <div className="card shadow-sm p-3" style={{ border: 'none', backgroundColor: '#fff' }}>
                <div className="card-header" style={{ border: 'none', backgroundColor: '#fff' }}>
                <Link to= "/schedule-list">
                    <h5 className="welcome-text" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}><i class="fa fa-arrow-left" style={{marginRight:'30px'}}aria-hidden="true"></i>Post Schedule Details</h5>
                      </Link>
                </div>
                <hr />
                {loading ? (
                    <div className='spinner'></div>
                ) : (
         
                    <div className="" key={posts[0].PostId}>
                   
                        <div><b style={{ color: "#2e3192" }}>Start Date:</b> {posts[0].StartDate?.split('T')[0]}</div>
                        <div className='mt-3'><b style={{ color: "#2e3192" }}>End Date:</b> {posts[0].EndDate?.split('T')[0]}</div>
                        <div className='mt-3'><b style={{ color: "#2e3192" }}>Prompt:</b> {(() => {
                          const p = posts[0] || {};
                          const candidates = [p.Prompt, p.Prompts, p.prompt, p.prompts, p.PromptID, p.promptId, p.promptID];
                          const first = candidates.find(v => typeof v === 'string' && v.trim().length);
                          if (first) {
                            const raw = first.trim();
                            return raw.includes('|') ? raw.split('|').join(',') : raw;
                          }
                          return '—';
                        })()}</div>
                        <div className='mt-3'><b style={{ color: "#2e3192" }}>Days:</b> {posts[0].Days}</div>
                     {AccountType =='User' &&   <div className='mt-3'><b style={{ color: "#2e3192" }}>Scheduled Email:</b> {posts[0].Email}</div>
                       }
                        <div className='mt-3'><b style={{ color: "#2e3192" }}>Time Zone:</b> {posts[0].TimeZone}</div>

                        {posts[0]?.ScheduledTimeAsPerZone && (
                  <div className="mt-3">
                    <b style={{ color: "#2e3192" }}>Scheduled Time:</b> {time}
                  </div>
                )}      </div>
                            )}
                  </div>
                  </div>


        </SideNavbar>
    );
};

export default ViewPostScheduleDet;
